import React from 'react';
import { useTranslation } from 'react-i18next';

const AIStarterSuggestionsModal = ({ isOpen, onClose, suggestions, onSelectSuggestion }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full text-white">
        <h3 className="text-xl font-bold mb-4 text-purple-300 font-playfair">{t('aiStarterSuggestionsModal.title')}</h3>
        <div className="space-y-3">
          {suggestions.map((suggestion, index) => (
            <button 
              key={index}
              onClick={() => onSelectSuggestion(suggestion)}
              className="w-full text-left p-4 bg-gray-700 rounded-lg hover:bg-purple-600 transition-colors"
            >
              {suggestion}
            </button>
          ))}
        </div>
        <div className="flex justify-end mt-6">
          <button onClick={onClose} className="px-4 py-2 bg-gray-600 rounded-md hover:bg-gray-700">{t('aiStarterSuggestionsModal.cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export default AIStarterSuggestionsModal;
